// SPEC-COLLECTION-OFFLINE-COMPLETE-01 (D-268i/j) PHASE_D D1/D2/FIX_D7 + D5 + FIX_D9/FIX_D10: 集金未送信の常時バナー。
//   PRIOR_ART = 巡回の UnsentBanner。表示様式(上部の amber ピル)を踏襲し、新様式を発明しない。決定7: 「自分の未送信」と
//   「この端末の他人の未送信」を分ける。0件かつ逼迫なしで非表示。
//   D-275 位置: 標準ヘッダ行(≈56px)より下へ。巡回バナー=top-14、集金ピル=top-24(巡回と非重なり)、容量警告=top-32。
//   これで D-274 でヘッダ右寄りに移した 先方サイン のタップをバナーが奪わない(バナーはヘッダの下・中央、サインは第1行)。
//   FIX_D9: タップ結果(送信/失敗/圏外)を既存 useToast で必ず伝える(無説明を残さない)。新しい通知の仕組みは作らない。
//   FIX_D10: useAuth の loading が終わるまで自分/他人の按分を出さない(認証確定前の誤按分=決定7 違反を避ける。合計のみ表示)。
import { useState } from 'react'
import { useCollectionUnsent } from '../hooks/useCollectionUnsent'
import { flushCollectionDrafts, describeFlushResult } from '../services/collectionSync'
import { useAuth } from '../hooks/useAuth'
import { useToast } from '../hooks/useToast'

export default function CollectionUnsentBanner() {
  const { mine, others, total, storage, refresh } = useCollectionUnsent()
  const { staffId, staffName, loading } = useAuth()
  const { showToast, Toast } = useToast()
  const [resending, setResending] = useState(false)
  const tight = !!storage?.tight
  // ⚠️ FIX_D11(D-268k): ここで早期 return null しない。それをすると <Toast/> ごと unmount され、再送成功(total→0)の
  //   結果トーストが読む前に消える(ひろ指摘)。ピル本体/容量警告だけを各 JSX ガード({total>0}/{tight})で条件表示し、
  //   Toast は無条件に常時描画する。コンポーネント全体からは絶対に null を返さない。

  async function handleResend() {
    setResending(true)
    let res = null
    try {
      res = await flushCollectionDrafts({ staff: { staffId, staffName }, skipProbe: false })
    } catch { /* flush は本来 throw しないが保険 */ }
    setResending(false)
    await refresh()
    // FIX_D9: 押した結果を必ず表示する。例外時も無説明にしない。
    if (!res) showToast('送信に失敗しました(未送信は端末に残っています)', 'error')
    else { const { msg, type } = describeFlushResult(res); showToast(msg, type) }
  }

  // FIX_D10: 認証確定前は按分を出さず合計のみ(誤って自分の未送信が他人として出るのを防ぐ)。
  const label = loading ? `集金未送信 ${total}件` : `集金未送信 自分${mine}件 / 他${others}件`
  const ariaBase = loading ? `集金未送信 ${total}件` : `集金未送信 自分${mine}件 他${others}件`

  return (
    <>
      {total > 0 && (
        <button
          type="button"
          data-testid="collection-unsent-banner"
          onClick={handleResend}
          disabled={resending}
          aria-label={`${ariaBase} タップで再送`}
          className="fixed top-24 left-1/2 -translate-x-1/2 z-[110] px-3 py-1 rounded-full bg-amber-600/90 text-white text-xs font-bold shadow active:scale-95 disabled:opacity-60"
        >
          {label}{resending ? ' …送信中' : ''}
        </button>
      )}
      {tight && (
        <div
          data-testid="collection-storage-warning"
          className="fixed top-32 left-1/2 -translate-x-1/2 z-[110] px-3 py-1 rounded-full bg-red-600/90 text-white text-[10px] font-bold shadow"
        >
          端末の空き容量が少なくなっています(未送信が保存できない恐れ)
        </div>
      )}
      <Toast />
    </>
  )
}
